import { render, staticRenderFns } from "./OffersListItem.vue?vue&type=template&id=d248e836"
import script from "./OffersListItem.vue?vue&type=script&lang=js"
export * from "./OffersListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports